import React from 'react';
import PropTypes from 'prop-types';

import './AuthenticationButton.css';

const AuthenticationButton = ({ children, href, type, disabled }) => (
  <a
    className={`authentication-button__component ${disabled ? 'disabled' : ''}`}
    href={disabled ? '#' : href}
  >
    <div className={`icon ${type}`} />
    <div className="authentication-button-content">
      {children}
    </div>
  </a>
);

AuthenticationButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  href: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['google', 'instagram', 'facebook']),
};

AuthenticationButton.defaultProps = {
  disabled: false,
  type: 'google',
};

export default AuthenticationButton;
